import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { CustomForm, CustomFormControllerApi } from "../../services";
import { Identified } from "../../types/sdk-types";
import {
  asPaginatedContent,
  getConfigObject,
  useBaseContent,
} from "../../utils/utils";

interface UseFormBuilderByUuidProps {
  customFormId?: string;
  xTENANTID?: string;
  disabled?: boolean;
  publicView?: boolean;
}

/**
 *
 * @author Rajkumar Rathod
 */
export function useFormBuilderByUuid({
  customFormId,
  publicView,
  xTENANTID,
  disabled,
}: UseFormBuilderByUuidProps): useBaseContent<Identified<CustomForm>> {
  return useQuery({
    queryKey: ["form-builder-by-uuid", customFormId, xTENANTID],
    enabled: !!customFormId && !disabled,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    queryFn: async () =>
      new CustomFormControllerApi(publicView ? undefined : getConfigObject())
        .getCustomFormByUuid(customFormId!, xTENANTID)
        .then((res) => asPaginatedContent<Identified<CustomForm>>(res?.data)),
  });
}
